import React from 'react';
import { Modal, Table, Form, Empty, Input, Button } from 'antd';
import "./styles.css";
export default class BuscarProductoModal extends React.Component {
    render() {
        return (
            <Modal
                title={this.props.title==undefined ?"Búsqueda de Producto":this.props.title}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                onCancel={this.props.onCancel}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={this.props.onCancel}
                    >
                        Cerrar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Input.Search
                                placeholder="Búsqueda por código o nombre"
                                autoComplete="off"
                                onChange={(e) => this.props.onChange(e.target.value)}
                                onSearch={value => this.props.onSearch(value)} 
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues.dataSource}
                                rowClassName='cursor-pointer'
                                className={'tableproducto'}
                                 rowSelection={{
                                     onChange: this.props.onChangeRow,
                                     selectedRowKeys: this.props.formValues.selectedRowKeys,
                                     hideDefaultSelections: false
                                 }}
                                //onRow={(item) => ({ onClick: () => (this.props.onChangeRow(item)) })}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Código',
                                        dataIndex: 'codigoReferencia',
                                        key: 'codigoReferencia'
                                    },
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'nombre',
                                        key: 'nombre'
                                    },
                                    {
                                        title: 'Tipo de Producto',
                                        dataIndex: 'nombreTipoProducto',
                                        key: 'nombreTipoProducto'
                                    },
                                    {
                                        title: 'Unidad de Medida',
                                        dataIndex: 'nombreUnidadMedida',
                                        key: 'nombreUnidadMedida'
                                    }
        
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}